"use strict";
'use es6'; // https://timleland.com/money-in-javascript/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCentsToDollars = exports.formatDollarsToCents = void 0;

var formatDollarsToCents = function formatDollarsToCents(_value) {
  var value = ("" + _value).replace(/[^\d.-]/g, '');

  if (value && value.includes('.')) {
    value = value.substring(0, value.indexOf('.') + 3);
  }

  return value ? Math.round(parseFloat(value) * 100) : 0;
};

exports.formatDollarsToCents = formatDollarsToCents;

var formatCentsToDollars = function formatCentsToDollars(_value) {
  var value = ("" + _value).replace(/[^\d.-]/g, '');

  value = parseFloat(value);
  return value ? value / 100 : 0;
};

exports.formatCentsToDollars = formatCentsToDollars;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/utils/currency.js
// module id = 411
// module chunks = 209 210 211 212